// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CBrt","delete":"styles_delete__6UBc8","update":"styles_update__3eCRo","add":"styles_add__2JQyi"};